export enum ConnectionType {
    ASPNET,
    VIRTUAL
}
